import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box,
    Button,
    Divider,
    Flex,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Radio, RadioGroup,
    Select,
    Spinner,
    Switch,
    Table,
    Tbody,
    Td,
    Text,
    Textarea,
    Th,
    Thead,
    Tooltip,
    Tr,
    useToast,
    Checkbox,
    useColorModeValue,
    useDisclosure,
} from '@chakra-ui/react';
import BuildUrlParamsUpdate from 'components/adspresso/BuildUrlParamsUpdate';
import FaceBookPageSelector from 'components/adspresso/FaceBookPageSelector';
import InstagramAccountUpdateSelector from 'components/adspresso/InstagramAccountUpdateSelector';
import UrlParametersUpdate from 'components/adspresso/UrlParametersUpdate';
import DriveModal from 'components/drive/DriveModal';
import { useFormik } from 'formik';
import { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useGetAdCreativeQuery, useGetInstantFormsByPageIdQuery, useUpdateAdMutation } from 'store/campaigns/adsApi';
import * as Yup from 'yup';
import { getCallToActionOptions, removeEmptyValues } from 'utils/functions';
import {
    call_to_action_options,
    call_to_action_options_instantForms,
    call_to_action_options_app_promptions,
    call_to_action_options_for_app_leads_and_sales,
    call_to_action_options_whatsapp,
    call_to_action_options_Awareness_Traffic_Engagement
} from 'utils/callToActions';
import { BsStars } from 'react-icons/bs';
import AiVideoModal from 'components/aiHub/AiVideoModal';
import { useGetAdvertisableAppsQuery } from 'store/campaigns/adsetFormApi';
import AdPreviews from 'components/genericForms/AdPreviews';
import { MdOutlineEdit } from 'react-icons/md';
import MessageTemplateModal from 'components/genericForms/MessageTemplateModal';

const SingleVideoAdUpdateForm = ({ adData, adsAccountData, onClose }) => {
    const toast = useToast();
    const background = useColorModeValue('gray.50', 'gray.800');
    const buttonBackgroundColor = useColorModeValue('gray.50', 'gray.800');
    const backgroundColor = useColorModeValue('#F5F3F9', '#1e1530');
    const { isOpen: isAiModalOpen, onOpen: onAiModalOpen, onClose: onAiModalClose } = useDisclosure();
    const { isOpen: isMessageModalOpen, onOpen: onMessageModalOpen, onClose: onMessageModalClose } = useDisclosure();
    const [isDriveModalOpen, setIsDriveModalOpen] = useState(false);
    const [isEnabled, setIsEnabled] = useState(false);
    const [isUrlModalOpen, setUrlModalOpen] = useState(false);
    const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const { data: adCreative, isLoading } = useGetAdCreativeQuery(
        {
            creativeId: adData?.id,
            adsAccountId: adsAccountData?.account_id
        },
        { skip: !adData?.id }
    );

    const { data: advertisableApps } = useGetAdvertisableAppsQuery({adsAccountId: adsAccountData?.account_id}, {skip: !adsAccountData?.account_id});

    const [updateAd] = useUpdateAdMutation();


    const pageId = adData?.adset?.promoted_object?.page_id || adCreative?.creative?.object_story_spec?.page_id;

    const formattedPageIds = (Array.isArray(pageId) ? pageId : [pageId]).filter(Boolean);

    const { data: instantForms } = useGetInstantFormsByPageIdQuery(
        { pageIds: formattedPageIds },
        { skip: !formattedPageIds.length || !['ON_AD', 'WEBSITE_AND_LEAD_FORM'].includes(adCreative?.adset?.destination_type)}
    );

    let pageIdToSend = null;
    if (
        adCreative?.adset?.destination_type === "PHONE_CALL" &&
        adData?.adset?.promoted_object?.page_id
    ) {
        pageIdToSend = adData.adset.promoted_object.page_id;
    }else if (
        adCreative?.campaign?.objective === "OUTCOME_AWARENESS"
    ){
        pageIdToSend = adData.adset.promoted_object.page_id;
    } else if(
        adCreative?.adset?.destination_type === "ON_PAGE"
    ){
       pageIdToSend = adData?.adset?.promoted_object?.page_id;
    } else if (
        adCreative?.adset?.destination_type === "WHATSAPP"
    ) {
        pageIdToSend = adData?.adset?.promoted_object?.page_id;
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Ad Name is required'),
        cpa: Yup.number()
            .typeError('must be a number')
            .positive('must be a positive number'),
        creative: Yup.object().shape({
            // name: Yup.string().required('Headline is required'),
            object_story_spec: Yup.object().shape({
                video_data: Yup.object().shape({
                    // message: Yup.string().required('Primary Text is required'),
                    // title: Yup.string().required('Headline is required'),
                    // link_description: Yup.string().required('Description is required'),
                    // video_id: Yup.string().required('Video ID is required'),
                    call_to_action: Yup.object().shape({
                        type: Yup.string().required('Call to action type is required'),
                        value: Yup.object().shape({
                            destinationType: Yup.string(),
                            link: Yup.string()
                                .when('destinationType', {
                                    is: (value) => ['PHONE_CALL'].includes(value),
                                    then: () => Yup.string()
                                    .transform((value) => {
                                        if (value == null) return '';
                                            return String(value).replace(/^tel:\+?/, '');
                                        })
                                    .matches(/^[0-9]{12,15}$/, 'Phone number must be between 10 and 15 digits')
                                    .required('Phone number is required'),
                                    otherwise: () => Yup.string().notRequired(),
                            }),
                            urlLink: Yup.string()
                                .when('destinationType', {
                                    is: (value) => ['WEBSITE', 'WEBSITE_AND_PHONE_CALL', 'OUTCOME_AWARENESS', "WEBSITE_AND_LEAD_FORM"].includes(value),
                                    then: () => Yup.string()
                                        .required('URL is required'),
                                    otherwise: () => Yup.string().notRequired(),
                            }),
                            lead_gen_form_id: Yup.string()
                                .when('destinationType', {
                                    is: (value) => ['ON_AD', 'WEBSITE_AND_LEAD_FORM'].includes(value),
                                    then: () => Yup.string()
                                        .required('Instant form is required'),
                                    otherwise: () => Yup.string().notRequired(),
                                }),
                        }),
                    }),
                }),
                page_id: Yup.string().required('Facebook Page is required'),
                // instagram_user_id: Yup.string().required('Instagram Actor ID is required'),
            }),
        }),
        destination_type: Yup.string(),
        phoneNumber: Yup.string()
            .when('destination_type', {
                is: (value) => ['WEBSITE_AND_PHONE_CALL'].includes(value),
                then: () => Yup.string()
                    .transform((value) => {
                    if (value == null) return '';
                        return String(value).replace(/^tel:\+?/, '');
                    })
                    .matches(/^[0-9]{12,15}$/, 'Phone number must be between 10 and 15 digits')
                    .required('Phone number is required'),
                otherwise: () => Yup.string().notRequired(),
            }),
        image_url: Yup.string().url('Invalid URL'),
    });

    const formik = useFormik({
        initialValues: {
            name: adData?.name || '',
            hash: adData?.hash || '',
            cpa: adData?.cpa || undefined,
            page_backed_insta_id: '',
            enroll_status: adCreative?.creative?.contextual_multi_ads?.enroll_status ? adCreative?.creative?.contextual_multi_ads?.enroll_status : 'OPT_OUT',
            pac_relaxation_enroll_status: adCreative?.creative?.degrees_of_freedom_spec?.creative_features_spec?.pac_relaxation?.enroll_status || 'OPT_IN',
            creative: {
                name: adCreative?.creative?.name || '',
                url_tags: adCreative?.creative?.url_tags || '',
                app_product_page_id: adCreative?.creative?.asset_feed_spec?.app_product_page_id || '',
                app_id: adCreative?.creative?.template_url_spec?.config?.app_id || '',
                object_story_spec: {
                    video_data: {
                        message: adCreative?.creative?.object_story_spec?.video_data?.message || '',
                        title: adCreative?.creative?.object_story_spec?.video_data?.title || '',
                        link_description: adCreative?.creative?.object_story_spec?.video_data?.link_description || '',
                        video_id: adCreative?.creative?.object_story_spec?.video_data?.video_id || '',
                        call_to_action: {
                            type: adCreative?.creative?.object_story_spec?.video_data?.call_to_action?.type || '',
                            value: {
                                destinationType: adCreative?.campaign?.objective === "OUTCOME_AWARENESS" ? adCreative?.campaign?.objective : adCreative?.adset?.destination_type ? adCreative?.adset?.destination_type : '',
                                link: adCreative?.adset?.destination_type === 'APP' ? adCreative?.creative?.object_story_spec?.video_data?.call_to_action?.value?.app_link : adCreative?.creative?.object_story_spec?.video_data?.call_to_action?.value?.link,
                                link_caption: adCreative?.creative?.object_story_spec?.video_data?.call_to_action?.value?.link_caption || '',
                                urlLink: adCreative?.creative?.object_story_spec?.video_data?.call_to_action?.value?.link,
                                lead_gen_form_id: adCreative?.creative?.object_story_spec?.video_data?.call_to_action?.value?.lead_gen_form_id 
                            },
                        },
                        page_welcome_message: (() => {
                            const raw = adCreative?.creative?.object_story_spec?.video_data?.page_welcome_message;
                              return typeof raw === 'string' ? JSON.parse(raw) : raw;
                        })()  
                    },
                    page_id: adCreative?.creative?.object_story_spec?.page_id || '',
                    instagram_user_id: adCreative?.creative?.object_story_spec?.instagram_user_id || '',
                },
            },
            destination_type: adCreative?.campaign?.objective === "OUTCOME_AWARENESS" ? adCreative?.campaign?.objective : adCreative?.adset?.destination_type ? adCreative?.adset?.destination_type : '',
            phoneNumber: adCreative?.creative?.asset_feed_spec?.call_ads_configuration?.phone_number,
            image_url: adCreative?.creative?.image_url || '',
            picture: adCreative?.creative?.picture || '',
        },
        validationSchema,
        enableReinitialize: true,
        validateOnMount: true,
        onSubmit: (values, { setSubmitting }) => {
            setIsSaving(true);

            const isCreativeChanged = () => {
                const original = adCreative?.creative || {};
                const updated = values.creative || {};

                // Compare specific fields
                return (
                    original.name !== updated.name ||
                    original.object_story_spec?.video_data?.message !== updated.object_story_spec?.video_data?.message ||
                    original.object_story_spec?.video_data?.title !== updated.object_story_spec?.video_data?.title ||
                    original.object_story_spec?.video_data?.link_description !== updated.object_story_spec?.video_data?.link_description ||
                    original.object_story_spec?.video_data?.video_id !== updated.object_story_spec?.video_data?.video_id ||
                    original.object_story_spec?.video_data?.call_to_action?.type !== updated.object_story_spec?.video_data?.call_to_action?.type ||
                    original.object_story_spec?.video_data?.call_to_action?.value?.link !== updated.object_story_spec?.video_data?.call_to_action?.value?.link ||
                    original.object_story_spec?.video_data?.call_to_action?.value?.link_caption !== updated.object_story_spec.video_data.call_to_action.value.link_caption ||
                    original.object_story_spec?.page_id !== updated.object_story_spec?.page_id ||
                    original.object_story_spec?.instagram_user_id !== updated.object_story_spec?.instagram_user_id ||
                    original.image_url !== values.image_url ||
                    original.url_tags !== updated.url_tags
                );
            };

            const formatPhoneNumber = (phoneNumber) => {

                if (!phoneNumber.startsWith('tel:+')) {
                    return `tel:+${phoneNumber}`;
                }
                return phoneNumber;
            };

            const hasCreativeChanged = isCreativeChanged();

            const initialPayload = {
                ...(hasCreativeChanged && {
                    creative: {
                        object_type : "VIDEO",
                        hash: values.hash,
                        ...(values.creative?.url_tags?.trim() && { url_tags: values.creative.url_tags }),
                        object_story_spec: {
                            video_data: {
                                image_url: values.image_url,
                                ...(values.creative.object_story_spec.video_data.message?.trim() && {
                                    message: values.creative.object_story_spec.video_data.message
                                }),
                                video_id: values.creative.object_story_spec.video_data.video_id,
                                ...((values.creative.object_story_spec.video_data.call_to_action.type !== 'LIKE_PAGE') && {
                                    title: values.creative.name,
                                    link_description: values.creative.object_story_spec.video_data.link_description,
                                }),
                                call_to_action: {
                                    type: values.creative.object_story_spec.video_data.call_to_action.type,
                                    value: adCreative?.adset?.destination_type === 'ON_AD'
                                        ? {
                                            lead_gen_form_id: values.creative.object_story_spec.video_data.call_to_action?.value?.lead_gen_form_id,
                                            link_caption: values.creative.object_story_spec.video_data.call_to_action.value.link_caption,
                                        } : adCreative?.adset?.destination_type === 'WHATSAPP'
                                        ? {
                                            app_destination: "WHATSAPP",
                                            link: "https://api.whatsapp.com/send"
                                        }
                                        : adCreative?.adset?.destination_type === 'WEBSITE_AND_LEAD_FORM'
                                        ? {
                                            lead_gen_form_id: values.creative.object_story_spec.video_data.call_to_action?.value?.lead_gen_form_id,
                                            link_caption: values.creative.object_story_spec.video_data.call_to_action.value.link_caption,
                                            link: values.creative.object_story_spec.video_data.call_to_action.value.urlLink,
                                        } : adCreative?.adset?.destination_type === 'APP' ?
                                            {
                                                app_link: values.creative.object_story_spec.video_data.call_to_action.value.link,
                                                link: adData?.adset?.promoted_object?.object_store_url,
                                            } : values.creative.object_story_spec.video_data.call_to_action.type === "LIKE_PAGE" ?
                                            {
                                                page:values.creative.object_story_spec.page_id
                                            }
                                            :
                                            {
                                                link: values.creative.object_story_spec.video_data.call_to_action.type === "CALL_NOW"
                                                    ? formatPhoneNumber(values.creative.object_story_spec.video_data.call_to_action.value.link)
                                                    : values.creative.object_story_spec.video_data.call_to_action.value.urlLink,
                                                ...(!['CALL_NOW', 'LIKE_PAGE'].includes(values.creative.object_story_spec.video_data.call_to_action.type)) && {
                                                    link_caption: values.creative.object_story_spec.video_data.call_to_action.value.link_caption,
                                                },
                                            }
                                },
                                ...((['WHATSAPP'].includes(adCreative?.adset?.destination_type)) && { page_welcome_message: values?.creative.object_story_spec.video_data.page_welcome_message }),
                            },
                            page_id: values.creative.object_story_spec.page_id,
                            ...(values.creative.object_story_spec.instagram_user_id?.trim() && {
                                instagram_user_id: values.creative.object_story_spec.instagram_user_id,
                            }),
                        },
                        contextual_multi_ads: {
                            enroll_status: values.enroll_status,
                        },
                        ...(adCreative?.adset?.destination_type === 'APP' && {
                            asset_feed_spec: {
                                app_product_page_id: values.creative.app_product_page_id,
                            }
                        }),
                        ...(adCreative?.adset?.destination_type === 'WEBSITE_AND_PHONE_CALL' && {
                            asset_feed_spec : {
                                call_ads_configuration: {
                                    call_destination_type : "WEBSITE_AND_CALL",
                                    phone_number: formatPhoneNumber(values.phoneNumber)
                                }
                            }
                        }),
                        ...((adCreative?.campaign?.objective === "OUTCOME_AWARENESS" || adCreative?.adset?.destination_type === 'ON_VIDEO') && {
                            template_url_spec: {
                                config: {
                                    app_id: values.creative.app_id,
                                }
                            }
                        }),
                        ...((["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(adCreative?.campaign?.objective)) &&
                            (values.creative.object_story_spec.video_data.call_to_action.type !== 'LIKE_PAGE') &&
                            (!['WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(adCreative?.adset?.destination_type)) && {
                                degrees_of_freedom_spec: {
                                    creative_features_spec: {
                                    pac_relaxation: {
                                        enroll_status: values?.pac_relaxation_enroll_status,
                                    },
                            }
                        }
                        })
                    },
                }),
                ...(values.name !== adData.name ? { name: values.name } : {}), // Include name only if it has changed
                ...(values.cpa && values.cpa !== '' && values.cpa !== adData.cpa ? { cpa: values.cpa } : {}),
                ...(["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(adCreative?.campaign?.objective) && {
                    objective: adCreative?.campaign?.objective,
                }),
                destination_type: adCreative?.adset?.destination_type,
                adsAccount: {
                    id: adsAccountData?.id,
                    adsAccountId: adsAccountData?.account_id,
                    adsAccountName: adsAccountData?.name,
                    businessName: adsAccountData?.business?.name,
                    businessId: adsAccountData?.business?.id
                },
            };

            const payload = removeEmptyValues(initialPayload);

            updateAd({ creativeId: adData.id, payload })
                .unwrap()
                .then(response => {
                    toast({
                        position: "top-right",
                        title: "Ad updated",
                        status: "success",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .catch(error => {
                    toast({
                        position: "top-right",
                        title: "Error updating ad",
                        description: error?.data?.message,
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .finally(() => {
                    setSubmitting(false);
                    setIsSaving(false);
                    setIsEnabled(false);
                    onClose();
                });
        },
    });

    const handleOpenDriveModal = () => {
        setIsDriveModalOpen(true);
    };

    const handleMediaSelect = (file) => {
        if (file && file.length > 0) {
            const selectedFile = file[0];

            formik.setFieldValue('hash', selectedFile?.hash);
            formik.setFieldValue('image_url', selectedFile?.picture);
            formik.setFieldValue('creative.object_story_spec.video_data.video_id', selectedFile?.creativeId);
        }
        setIsDriveModalOpen(false);
    };

    if (isLoading) {
        return <Flex justify="center" align="center" height="60vh">
            <Spinner size="md" />
        </Flex>
    }

    const handleUrlChange = (constructedUrl) => {
        formik.setFieldValue('creative.object_story_spec.video_data.call_to_action.value.urlLink', constructedUrl);
    };

    const handleUrlParamChange = (constructedUrl) => {
        formik.setFieldValue('creative.url_tags', constructedUrl);
    };

    const filteredInstantForms = instantForms?.length > 0 && instantForms
        .map((formResponse) => formResponse?.data?.data) // Get the 'data' array from each formResponse
        .flat() // Flatten the array to get all forms in one array
        .filter((form) => form?.page_id === pageId);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Flex gap={4}>
                <Box direction={'column'} gap={4} width="100%" flex={0.4}>
                    <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Ad Name</Text>
                            <Input
                                name="name"
                                placeholder="Enter your ad name here..."
                                bg="#fff"
                                size='sm'
                                borderRadius="md"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                            />
                            {formik.errors.name && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.name}</Text>
                            )}
                        </Flex>

                        <Flex direction="column" gap={1} mb={2}>
                            <Text fontWeight="bold">Facebook Page</Text>
                            <FaceBookPageSelector
                                adsAccount={adsAccountData}
                                selectedPageId={formik.values.creative?.object_story_spec?.page_id}
                                pageIdToSend={pageIdToSend}
                                onSelectedPage={(pageId) => {
                                    formik.setFieldValue('creative.object_story_spec.page_id', pageId);

                                    // Reset the Instagram actor ID to an empty string
                                    formik.setFieldValue('creative.object_story_spec.instagram_user_id', '');
                                }}
                            />
                            {formik.touched.creative?.object_story_spec?.page_id && formik.errors.creative?.object_story_spec?.page_id && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.object_story_spec?.page_id}</Text>
                            )}
                        </Flex>

                        {adCreative?.adset?.destination_type === 'ON_PAGE' ? null : 
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Instagram accounts</Text>
                                <InstagramAccountUpdateSelector
                                    pageID={formik.values.creative?.object_story_spec?.page_id}
                                    adsAccount={adsAccountData}
                                    selectedInstPageId={formik.values.creative?.object_story_spec?.instagram_user_id}
                                    onSelectedPage={(pageId) => {
                                        formik.setFieldValue('creative.object_story_spec.instagram_user_id', pageId);
                                    }}
                                    onPageBack={(pageId) => {
                                        formik.setFieldValue('page_backed_insta_id', pageId);
                                    }}
                                />
                            </Flex>
                        }
                    </Flex>

                    <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="row" mb={4} gap={2} alignItems={'center'}>
                            <Flex direction={'column'} gap={2}>
                                <Text fontWeight="bold">Creative</Text>
                                {false ? (
                                    <Spinner size="sm" color="gray.500" />
                                ) : (
                                    formik.values.image_url && (
                                        <img
                                            src={formik.values.image_url}
                                            alt={formik.values.name}
                                            style={{
                                                width: '100px',
                                                height: '100px',
                                                objectFit: 'cover',
                                                border: '0.5px solid grey',
                                                borderRadius: '5px',
                                            }}
                                        />
                                    )
                                )}
                            </Flex>
                            <Flex direction={'column'} mt={6} gap={2}>
                                <Flex mt={6}>
                                    <Button
                                        bg={buttonBackgroundColor}
                                        size="xs"
                                        borderWidth={1}
                                        onClick={handleOpenDriveModal}>
                                        Change Video
                                    </Button>
                                </Flex>
                                <Flex alignItems={'center'} gap={2}>
                                    <Button
                                        colorScheme='brand'
                                        size="xs"
                                        onClick={onAiModalOpen}
                                        leftIcon={<BsStars />}
                                    >
                                        AI Video Generation
                                    </Button>

                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Flex direction={'column'} gap={2} fontSize="12px" p="5px">
                                                <Text fontWeight={'bold'}>Generated with AI</Text>
                                                <Text>AI-generated video variations are inspired by your original asset. Adding multiple image options to your ad can help tailor creatives to different audiences, reduce creative fatigue, and improve overall performance.</Text>
                                                <Flex direction={'column'} gap={2}>
                                                    <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                    <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                                                    <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                                                </Flex>
                                                <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated videos.</Text>
                                            </Flex>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                            </Flex>
                        </Flex>

                        {/* Multi-advertiser ads Section */}
                        <Flex direction="column" mb={2} gap={2}>
                            <Checkbox
                                onChange={(e) => {
                                    formik.setFieldValue("enroll_status", e.target.checked ? 'OPT_IN' : 'OPT_OUT');
                                }}
                                colorScheme="brand"
                                isChecked={formik.values.enroll_status === 'OPT_IN'}
                            >
                                <Flex align={'center'}>
                                    <Text fontWeight="bold" fontSize={'14px'}>Multi-advertiser ads &nbsp;</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Your ads can appear alongside other ads in the same ad unit to help people discover products and services from businesses that are personalized to them. Your ad creative may be resized or cropped to fit the ad unit.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                            </Checkbox>
                        </Flex>

                        {["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(adCreative?.campaign?.objective) && !['ON_PAGE','WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(adCreative?.adset?.destination_type) ?
                            <Flex direction={'column'} gap={2} mb={2}>
                                <Flex alignItems="center">
                                    <Text fontWeight="bold" mr={2}>Flexible media</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Flex direction={'column'} fontSize="12px" p="5px" gap={2}>
                                                <Text fontWeight={'bold'}>Flexible media</Text>
                                                <Text>Show media that you chose for a specific aspect ratio across all placements when it's likely to improve performance. You can turn off flexible media at any time in ad creative.</Text>
                                                <Text>To preview flexible media, select a specific placement group at the top of Ad preview.</Text>
                                            </Flex>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Flex alignItems={'center'} gap={2}>
                                    <Switch colorScheme='brand' size={'sm'} isChecked={formik.values.pac_relaxation_enroll_status === 'OPT_IN'} onChange={(e) => formik.setFieldValue('pac_relaxation_enroll_status', e.target.checked ? 'OPT_IN' : 'OPT_OUT')} />
                                    <Text fontSize="12px">We'll deliver your media selections across your placements when it's likely to improve performance.</Text>
                                </Flex>
                            </Flex>
                        :null}

                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Primary Text</Text>
                            <Textarea
                                name="creative.object_story_spec.video_data.message"
                                placeholder="Message"
                                bg="#fff"
                                size='sm'
                                borderRadius="md"
                                value={formik.values.creative.object_story_spec.video_data.message}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.creative?.object_story_spec?.video_data?.message && formik.errors.creative?.object_story_spec?.video_data?.message && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.object_story_spec?.video_data?.message}</Text>
                            )}
                        </Flex>

                        {adCreative?.adset?.destination_type === 'ON_PAGE' ? null :
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Headline</Text>
                                <Input
                                    name="creative.object_story_spec.video_data.title"
                                    placeholder="Enter a headline"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.object_story_spec.video_data.title}
                                    onChange={formik.handleChange}
                                />
                            </Flex>
                        }
                    
                        {['APP','ON_PAGE'].includes(adCreative?.adset?.destination_type) ? null :
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Description</Text>
                                <Textarea
                                    name="creative.object_story_spec.video_data.link_description"
                                    placeholder="Include additional details"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.object_story_spec.video_data.link_description}
                                    onChange={formik.handleChange}
                                />
                            </Flex>
                        }

                        {adCreative?.adset?.destination_type === 'ON_PAGE' ? null :             
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Call to Action</Text>

                                {adCreative?.adset?.destination_type === 'PHONE_CALL' ? (
                                    <Select
                                        name="creative.object_story_spec.video_data.call_to_action.type"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.creative.object_story_spec.video_data.call_to_action.type}
                                        isDisabled
                                    >
                                        <option value="CALL_NOW">Call Now</option>
                                    </Select>
                                ) : ['ON_AD', 'WEBSITE_AND_LEAD_FORM'].includes(adCreative?.adset?.destination_type) ? (
                                    <Select
                                        name="creative.object_story_spec.video_data.call_to_action.type"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.creative.object_story_spec.video_data.call_to_action.type}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options_instantForms,
                                            formik.values.creative.object_story_spec.video_data.call_to_action.type
                                        ).map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : adCreative?.adset?.destination_type === 'APP' && adData?.campaign?.objective === 'OUTCOME_APP_PROMOTION' ? (
                                    <Select
                                        name="creative.object_story_spec.video_data.call_to_action.type"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.creative.object_story_spec.video_data.call_to_action.type}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options_app_promptions,
                                            formik.values.creative.object_story_spec.video_data.call_to_action.type
                                        ).map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : adCreative?.adset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(adCreative?.campaign?.objective) ? (
                                    <Select
                                        name="creative.object_story_spec.video_data.call_to_action.type"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.creative.object_story_spec.video_data.call_to_action.type}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options_for_app_leads_and_sales,
                                            formik.values.creative.object_story_spec.video_data.call_to_action.type
                                        ).map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : adCreative?.adset?.destination_type === 'WHATSAPP' ? (
                                    <Select
                                        name="creative.object_story_spec.video_data.call_to_action.type"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.creative.object_story_spec.video_data.call_to_action.type}
                                        isDisabled={adCreative?.campaign?.objective === 'OUTCOME_LEADS'}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options_whatsapp,
                                            formik.values.creative.object_story_spec.video_data.call_to_action.type
                                        ).map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>    
                                ) : adCreative?.campaign?.objective === "OUTCOME_AWARENESS" ||  (["OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT"].includes(adCreative?.campaign?.objective) && adCreative?.adset?.destination_type === 'WEBSITE') || adCreative?.adset?.destination_type === 'ON_VIDEO' ? (
                                    <Select
                                        name="creative.object_story_spec.video_data.call_to_action.type"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.creative.object_story_spec.video_data.call_to_action.type}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options_Awareness_Traffic_Engagement,
                                            formik.values.creative.object_story_spec.video_data.call_to_action.type
                                        ).map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : (
                                    <Select
                                        name="creative.object_story_spec.video_data.call_to_action.type"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.creative.object_story_spec.video_data.call_to_action.type}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options,
                                            formik.values.creative.object_story_spec.video_data.call_to_action.type
                                        ).map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                )}

                                {formik.touched.creative?.object_story_spec?.video_data?.call_to_action?.type &&
                                    formik.errors.creative?.object_story_spec?.video_data?.call_to_action?.type && (
                                        <Text fontSize="12px" color="red.500">
                                            {formik.errors.creative.object_story_spec.video_data.call_to_action.type}
                                        </Text>
                                    )}
                            </Flex>
                        }

                        {['PHONE_CALL'].includes(adCreative?.adset?.destination_type) && (
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Phone Number</Text>
                                <PhoneInput
                                    name="creative.object_story_spec.video_data.call_to_action.value.link"
                                    value={formik.values.creative.object_story_spec.video_data.call_to_action.value.link}
                                    onChange={(value) => formik.setFieldValue('creative.object_story_spec.video_data.call_to_action.value.link', value)}
                                    country={'in'}
                                />
                                {formik.errors.creative?.object_story_spec?.video_data?.call_to_action?.value?.link && (
                                    <Text fontSize="12px" color="red.500">{formik.errors.creative.object_story_spec.video_data.call_to_action.value.link}</Text>
                                )}
                            </Flex>
                        )}

                        {['WEBSITE', 'ON_VIDEO', 'WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(adCreative?.adset?.destination_type) || adCreative?.campaign?.objective === "OUTCOME_AWARENESS" ? (
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Website URL</Text>
                                <Input
                                    name="creative.object_story_spec.video_data.call_to_action.value.urlLink"
                                    placeholder="Enter a URL"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.object_story_spec.video_data.call_to_action.value.urlLink}
                                    onChange={formik.handleChange}
                                />
                                <Flex mt={2}>
                                    <Button onClick={() => {
                                        setUrlModalOpen(true)
                                    }}
                                        variant="link"
                                        color='brand'>
                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                    </Button>
                                </Flex>
                                {formik.errors.creative?.object_story_spec?.video_data?.call_to_action?.value?.urlLink && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.object_story_spec?.video_data?.call_to_action?.value?.urlLink}</Text>
                                )}
                            </Flex>
                        ) : (null)}

                        {['WEBSITE_AND_PHONE_CALL'].includes(adCreative?.adset?.destination_type) && (
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Phone Number</Text>
                                <PhoneInput
                                    name="phoneNumber"
                                    value={formik.values.phoneNumber}
                                    onChange={(value) => formik.setFieldValue('phoneNumber', value)}
                                    country={'in'}
                                />
                                {formik.errors.phoneNumber && (
                                    <Text fontSize="12px" color="red.500">{formik.errors.phoneNumber}</Text>
                                )}
                            </Flex>
                        )}

                        {adCreative?.adset?.destination_type === 'APP' && adData?.campaign?.objective === 'OUTCOME_APP_PROMOTION'  ? (
                            <>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Deferred deep link</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text fontWeight={'bold'}>Using a deferred deep link</Text><br></br>
                                                    <Text mb={2}>A deferred deep link is a URL that sends people to your app in the respective app store. Once people install your app, the link will take them to a specific screen, such as a product page.</Text>
                                                    <Text mb={2}>To use a deferred deep link, you need to first connect the Facebook SDK. You can use any of these link types:</Text>
                                                    <Box>
                                                        <Text>* Android app link</Text>
                                                        <Text>* Custom URL scheme</Text>
                                                        <Text>* Facebook app link</Text>
                                                    </Box>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="creative.object_story_spec.video_data.call_to_action.value.link"
                                        placeholder="Enter a deferred deep link URL"
                                        bg="#fff"
                                        size='sm'
                                        borderRadius="md"
                                        value={formik.values.creative.object_story_spec.video_data.call_to_action.value.link}
                                        onChange={formik.handleChange}
                                    />
                                </Flex>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Custom store listing</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text fontWeight={'bold'}>Using a custom store listing</Text><br></br>
                                                    <Text mb={2}>A custom store listing ID sends people who click your ad to a landing page that you've customised in the Google Play Store.</Text>
                                                    <Text mb={2}>Use this feature to create multiple custom product pages with different media and text that speak to your various audiences.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="creative.app_product_page_id"
                                        placeholder="Enter custome store listing ID"
                                        bg="#fff"
                                        size='sm'
                                        borderRadius="md"
                                        value={formik.values.creative.app_product_page_id}
                                        onChange={formik.handleChange}
                                    />
                                </Flex>
                            </>
                        ) : (null)}

                        {adCreative?.adset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(adCreative?.campaign?.objective) ? (
                            <>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Deep link</Text>
                                        <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="12px" p="5px">
                                                   <Text>Send people to a specific place in your app. You can use an Apple universal link, Android App Link, custom URL scheme or Facebook App Link.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="creative.object_story_spec.video_data.call_to_action.value.link"
                                        placeholder="Enter the deep link URL"
                                        bg="#fff"
                                        size='sm'
                                        borderRadius="md"
                                        value={formik.values.creative.object_story_spec.video_data.call_to_action.value.link}
                                        onChange={formik.handleChange}
                                    />
                                </Flex>
                            </>
                        ) : (null)}

                        {adCreative?.adset?.destination_type === 'ON_AD' && adData?.campaign?.objective === 'OUTCOME_LEADS' ? (
                            <>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold">Instant form</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>

                                {/* Table Layout */}
                                {filteredInstantForms?.length > 0 ? (
                                    <RadioGroup onChange={(value) => formik.setFieldValue('creative.object_story_spec.video_data.call_to_action.value.lead_gen_form_id', value)} value={formik.values.creative.object_story_spec.video_data.call_to_action.value.lead_gen_form_id} colorScheme="brand" mt={-2}>
                                        <Table variant="simple">
                                            <Thead>
                                                <Tr>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px" p={-1}>Form title</Th>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {filteredInstantForms?.map((form) => (
                                                    <Tr key={form?.id}>
                                                        <Td p={-1}>
                                                            <Flex alignItems="center" gap={2}>
                                                                <Radio value={form?.id} />
                                                                <Text color={form.status === 'DRAFT' ? "gray.500" : "none"} fontSize={'12px'}>
                                                                    {form?.name}
                                                                </Text>
                                                            </Flex>
                                                        </Td>
                                                        <Td>
                                                            <Text fontSize={'12px'}>
                                                                {new Date(form?.created_time).getFullYear()}-
                                                                {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                                {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                            </Text>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </RadioGroup>
                                ) : (
                                    <Text fontSize="14px" color="gray.500" mb={2}>No form data available</Text>
                                )}
                                {formik.touched?.creative?.object_story_spec?.video_data?.call_to_action?.value?.lead_gen_form_id &&
                                    formik.errors?.creative?.object_story_spec?.video_data?.call_to_action?.value?.lead_gen_form_id && (
                                        <Text fontSize="12px" color="red.500">
                                            {formik.errors.creative.object_story_spec.video_data.call_to_action.value.lead_gen_form_id}
                                    </Text>
                                )}
                            </>
                        ) : null}

                        {adCreative?.adset?.destination_type === 'WEBSITE_AND_LEAD_FORM' && adData?.campaign?.objective === 'OUTCOME_LEADS' ? (
                            <>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold">Instant form</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>

                                {/* Table Layout */}
                                {filteredInstantForms?.length > 0 ? (
                                    <RadioGroup onChange={(value) => formik.setFieldValue('creative.object_story_spec.video_data.call_to_action.value.lead_gen_form_id', value)} value={formik.values.creative.object_story_spec.video_data.call_to_action.value.lead_gen_form_id} colorScheme="brand" mt={-2}>
                                        <Table variant="simple">
                                            <Thead>
                                                <Tr>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px" p={-1}>Form title</Th>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {filteredInstantForms?.map((form) => (
                                                    <Tr key={form?.id}>
                                                        <Td p={-1}>
                                                            <Flex alignItems="center" gap={2}>
                                                                <Radio value={form?.id} />
                                                                <Text color={form.status === 'DRAFT' ? "gray.500" : "none"} fontSize={'12px'}>
                                                                    {form?.name}
                                                                </Text>
                                                            </Flex>
                                                        </Td>
                                                        <Td>
                                                            <Text fontSize={'12px'}>
                                                                {new Date(form?.created_time).getFullYear()}-
                                                                {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                                {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                            </Text>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </RadioGroup>
                                ) : (
                                    <Text fontSize="14px" color="gray.500" mb={2}>No form data available</Text>
                                )}
                                {formik.touched?.creative?.object_story_spec?.video_data?.call_to_action?.value?.lead_gen_form_id &&
                                    formik.errors?.creative?.object_story_spec?.video_data?.call_to_action?.value?.lead_gen_form_id && (
                                        <Text fontSize="12px" color="red.500">
                                            {formik.errors.creative.object_story_spec.video_data.call_to_action.value.lead_gen_form_id}
                                    </Text>
                                )}
                            </>
                        ) : null}

                        {['WHATSAPP'].includes(adCreative?.adset?.destination_type) ? (
                            <>
                                <Flex>
                                    <Text fontWeight={'bold'} fontSize={'sm'}>Message template</Text>
                                </Flex>
                            
                                {(() => {
                                const welcomeData = formik?.values?.creative?.object_story_spec?.video_data?.page_welcome_message;
                                    
                                const type = welcomeData?.text_format?.customer_action_type;

                                const greeting = welcomeData?.text_format?.message?.text || '';
                                const autofillMessage = welcomeData?.text_format?.message?.autofill_message?.content || '';
                                const iceBreakers = welcomeData?.text_format?.message?.ice_breakers || [];

                                return (
                                    <Box mb={2}>
                                        <Box border={'1px solid'} borderColor={'gray.200'} p={2} borderRadius={'md'} bg={backgroundColor}>
                                            <Text fontSize={'14px'}><strong>Greeting:</strong> {greeting}</Text>

                                            {type === 'autofill_message' && (
                                                <Text fontSize={'14px'}><strong>Pre-filled message:</strong> {autofillMessage}</Text>
                                            )}

                                            {type === 'ice_breakers' && (
                                                <>
                                                <Text fontSize={'14px'}><strong>Frequently asked questions</strong></Text>
                                                {iceBreakers.map((q, i) => (
                                                    <Text key={i} fontSize="14px">
                                                    {i + 1}. {q.title}
                                                    </Text>
                                                ))}
                                                </>
                                            )}
                                        </Box>

                                        <Button
                                            variant="outline"
                                            backgroundColor="transparent" 
                                            size={'sm'}
                                            leftIcon={<MdOutlineEdit />}
                                            mt={2}
                                            onClick={() => {
                                                onMessageModalOpen();
                                            }}
                                        >
                                            Edit
                                        </Button>
                                    </Box>
                                );
                                })()}
                            </>
                        ) : null}

                        {(["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(adCreative?.campaign?.objective) && !['PHONE_CALL', 'ON_PAGE', 'APP', 'WHATSAPP', 'ON_AD'].includes(adCreative?.adset?.destination_type))  ?  
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold" >Display link</Text>
                                <Input
                                    name="creative.object_story_spec.video_data.call_to_action.value.link_caption"
                                    placeholder="Enter the link that you want to show on your ad"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.object_story_spec.video_data.call_to_action.value.link_caption}
                                    onChange={formik.handleChange}
                                />
                            </Flex>
                        :null}

                        {adCreative?.campaign?.objective === "OUTCOME_AWARENESS" || adCreative?.adset?.destination_type === 'ON_VIDEO' ?
                            <Flex direction={'column'} gap={1}>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold" >Mobile app</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Only select a mobile app if you are using a universal link (iOS or Android app link).</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Select
                                    name={`creative.app_id`}
                                    bg="#fff"
                                    size="sm"
                                    borderRadius="md"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik?.values?.creative?.app_id}
                                >
                                    <option value="">Choose app</option>
                                    {advertisableApps?.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                                </Select>
                            </Flex>
                        : null}
                    </Flex>

                    {['APP', 'PHONE_CALL', 'ON_PAGE', 'WHATSAPP'].includes(adCreative?.adset?.destination_type) ? null :
                        <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                            <Text fontWeight={'bold'}>Tracking</Text>
                            <Flex direction="column" gap={1}>
                                <Flex alignItems={'center'}>
                                    <Text mb={2} fontWeight="bold">
                                        URL parameters{" "}
                                        {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                                        <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                    </Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p={'5px'}>
                                                <Text >
                                                    Add parameters to the end of your website URL to track where your visitors are coming from.
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                                    </Tooltip>
                                </Flex>
                                <Input
                                    name="creative.url_tags"
                                    placeholder="key1=value1&key2=value2"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.url_tags}
                                    onChange={formik.handleChange}
                                />
                                <Flex mt={2}>
                                    <Button onClick={() => {
                                        setUrlParamModalOpen(true)
                                    }}
                                        variant="link"
                                        color='brand'>
                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                    </Button>
                                </Flex>
                                {formik.touched.creative?.url_tags && formik.errors.creative?.url_tags && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.url_tags}</Text>
                                )}
                            </Flex>
                        </Flex>
                    }

                    <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">CPA</Text>
                            <Input
                                name="cpa"
                                placeholder="Enter CPA"
                                bg="#fff"
                                size='sm'
                                borderRadius="md"
                                value={formik.values.cpa}
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.cpa && formik.errors.cpa && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.cpa}</Text>
                            )}
                        </Flex>
                    </Flex>
                    <Flex mb={4}>
                        <Button
                            size="sm"
                            colorScheme="brand"
                            isLoading={formik.isSubmitting}
                            type="submit"
                            isDisabled={!formik.isValid}
                        >
                            Save
                        </Button>
                    </Flex>
                </Box>
                <Box
                    pos={'relative'}
                    flex={0.6}
                    px={4} borderRadius={'md'} boxShadow="0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)">
                    <Flex py={2} gap={2}>
                        <Switch isChecked={isEnabled} colorScheme='brand' onChange={() => setIsEnabled(prevState => !prevState)} />
                        <Text fontWeight={'bold'} fontSize={'14px'}>Ad preview  </Text>
                    </Flex>
                    <Divider />
                    {isEnabled && !isSaving &&
                        <AdPreviews adCreative={adCreative} file={formik?.values} adsAccountData={adsAccountData} />
                    }
                    <Flex p={2} alignItems={'center'} position={'absolute'} bottom={0}>
                        <Text fontSize={'12px'} mr={2}>Ad rendering and interaction may vary based on device, format and other factors.</Text>
                        <Tooltip
                            borderRadius={5}
                            label={
                                <Box fontSize="12px" p="5px">
                                    <Text>
                                        Ads Manager previews are just examples and are not a substitute for reviewing Help Centre guidance and testing formats and devices to ensure that your ad delivers as intended.
                                    </Text>
                                </Box>
                            }
                            fontSize="md"
                        >
                            <InfoOutlineIcon pointerEvents="all" boxSize={3} />
                        </Tooltip>
                    </Flex>
                </Box>

            </Flex>

            <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <BuildUrlParamsUpdate link={formik.values.creative.object_story_spec?.video_data?.call_to_action?.value} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <UrlParametersUpdate link={formik.values.creative} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            {/* Upload Video Modal */}
            <Modal
                size={"6xl"}
                isCentered={true}
                isOpen={isAiModalOpen}
                scrollBehavior={"inside"}
                onClose={onAiModalClose}
                closeOnOverlayClick={false}
                closeOnEsc={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        <Flex gap={2} direction={'column'}>
                            <Flex alignItems={'center'} gap={2}>
                                <BsStars />
                                <Text>AI Video Generation</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Flex direction={'column'} gap={2} fontSize="12px" p="5px">
                                            <Text fontWeight={'bold'}>AI Video Generation</Text>
                                            <Text>AI-generated video ads are created using your product information and visuals. By assembling product highlights, voiceovers, and dynamic visuals, the AI helps generate high-performing video ads optimised for various platforms.</Text>
                                            <Flex direction={'column'} gap={2}>
                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                <Text>Product URL Based: Extracts product details from your URL to auto-generate video content.</Text>
                                                <Text>Asset Based: Uses your uploaded visuals to create fully edited video ads.</Text>
                                            </Flex>
                                            <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated videos.</Text>
                                        </Flex>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                        </Flex>
                    </ModalHeader>
                    <ModalBody>
                        <AiVideoModal
                            isOpen={isAiModalOpen}
                            selectedAdAccounts={[{
                                id: adsAccountData?.id,
                                adsAccountId: adsAccountData?.account_id,
                                adsAccountName: adsAccountData?.name,
                                businessName: adsAccountData?.business?.name,
                                businessId: adsAccountData?.business?.id
                            }]}
                            onClose={() => {
                                onAiModalClose();
                            }}
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <MessageTemplateModal
                isOpen={isMessageModalOpen}
                onClose={onMessageModalClose}
                accountId={''}
                welcomeData={formik?.values?.creative?.object_story_spec?.video_data?.page_welcome_message}
                onSave={(updatedData) => {
                    formik.setFieldValue('creative.object_story_spec.video_data.page_welcome_message', updatedData);
                    onMessageModalClose();
                }}
            />

            {/* Drive Modal */}
            <DriveModal
                isDriveModalOpen={isDriveModalOpen}
                selectedAdAccounts={[{
                    id: adsAccountData?.id,
                    adsAccountId: adsAccountData?.account_id,
                    adsAccountName: adsAccountData?.name,
                    businessName: adsAccountData?.business?.name,
                    businessId: adsAccountData?.business?.id
                }]}
                onClose={() => setIsDriveModalOpen(false)}
                onSubmit={handleMediaSelect}
                uploadPurpose="update"
                mediaType="video"
            />
        </form>
    );
};

export default SingleVideoAdUpdateForm;